import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { characters } from "@/mocks/film";

export default function CharactersSection() {
  return (
    <section id="characters" className="scroll-mt-32 bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="03 / 主要角色"
            title="六位人物，撑起同一间屋子"
            desc="这部片没有多余的功能性配角，每个人都在关系网里承担明确作用。下面按出场重要度整理角色身份、性格与人物关系。"
          />
        </Reveal>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {characters.map((character, index) => (
            <Reveal key={character.name} delay={(index % 3) * 80}>
              <article className="group h-full rounded-lg bg-background-100 border border-background-200 overflow-hidden flex flex-col">
                <div className="w-full aspect-[4/5] overflow-hidden bg-background-200">
                  <img
                    src={character.image}
                    alt={`${character.name}（${character.role}）的角色概念图`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                </div>
                <div className="p-5 md:p-6 flex flex-col flex-1">
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="font-heading text-xl font-bold text-foreground-950">
                      {character.name}
                    </h3>
                    <span className="shrink-0 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label whitespace-nowrap">
                      {character.role}
                    </span>
                  </div>
                  <div className="mt-3 space-y-2 text-sm text-foreground-700">
                    <p className="flex gap-2">
                      <i className="ri-user-heart-line mt-0.5 text-primary-500" aria-hidden="true" />
                      <span>{character.trait}</span>
                    </p>
                    <p className="flex gap-2">
                      <i className="ri-link-m mt-0.5 text-primary-500" aria-hidden="true" />
                      <span>{character.relation}</span>
                    </p>
                  </div>
                  <p className="mt-4 pt-4 border-t border-background-200 text-sm leading-relaxed text-foreground-600">
                    {character.desc}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}